import processReport from '@/assets/js/report/order_packing'
export default {
  methods: {
    async genereatePackReportContent (getObj) {
      // let getObj = this.listPayloadObj.list ? this.listPayloadObj.list.find(x => x.id === id) : {}
      if (!getObj) getObj = {}
      let customerLang = (getObj && getObj.customer_language) ? getObj.customer_language : this.$i18n.locale
      let lang = this.$i18n.messages[customerLang].message
      if (getObj) {
        let headers = [{ text: lang.orders.productNo, value: 'number', width: '25%' },
          { text: lang.customer.name, value: 'producttext', width: '43%' },
          { text: lang.invoice.qty, value: 'qty', width: '8%' },
          { text: lang.order.deliveredQty, value: 'deliveredqty', width: '8%' },
          { text: lang.common.pickedqty, value: 'pickedqty', width: '8%' },
          { text: lang.order.rest, value: 'rest', width: '8%' }
        ]
        let products = await this.getOrderPackProducts(getObj.id, getObj.type, getObj.restcreatedfrom)
        let translationData = {
          confirm: lang.orders.packList,
          number: lang.order.orderNumber,
          customer: lang.order.customer,
          contact: lang.order.yourContactPerson,
          contactPhone: lang.order.contactPhone,
          currency: lang.product.currency,
          deliveryAddress: lang.orders.deliveryAddress,
          responsible: lang.deviations.responsible,
          ourreference: lang.orders.ourReference,
          yourreference: lang.orders.yourReference,
          offerdate: lang.orders.offerDate,
          orderdate: lang.whOrder.orderDate,
          deliverydate: lang.order.shippingDate,
          shipment: lang.customer.shipmentReport,
          paymentTerm: lang.order.paymentTerms,
          deliveryTerm: lang.order.deliveryTerm,
          invoiceTo: lang.orders.invoiceTo,
          invoiceAddress: lang.orders.invoiceAddress,
          days: lang.common.days,
          restorder: lang.orders.restOrderFor,
          saleRef: lang.invoiceReport.saleRef,
          phone: lang.customer.phone,
          yourOrderNum: lang.orders.yourOrderNumber,
          customerNum: lang.unimicro.customerNumber,
          labeled: lang.order.labeled
        }
        let getBase64Content = processReport(headers, products, getObj, translationData, getObj.restcreatedfromnumber, 3)
        return getBase64Content
      }
    },
    getOrderPackProducts (id, type, restOrder) {
      return new Promise((resolve, reject) => {
        this.$_executeApi('get', `ordermaterials/get_materials_packlist/${id}`)
          .then((response) => {
            if (response.data) {
              const allMaterials = response.data
              var pickedQtyCalculatedList = this.getPickedQtyCalculatedList(allMaterials)
              let getMaterialsForRest = pickedQtyCalculatedList.filter(x => !x.packageid && !x.mainpackageid && (x.orderindex === null || x.orderindex <= 0))
              getMaterialsForRest.map(x => {
                // check for splitted rows
                let getPicked = x.pickedqty
                var getChildren = pickedQtyCalculatedList.filter(z => z.orderindex === x.id)
                if (getChildren && getChildren.length > 0) {
                  getChildren.map(y => {
                    getPicked += y.pickedqty
                  })
                }
                const pickedQty = getPicked
                x.rest = pickedQty ? (x.qty - pickedQty) : x.qty
                if (x.isrestfirstrow) {
                  x.rest = pickedQty ? (x.realqty - pickedQty) : 0
                }
                x.qty = this.$formatter.replaceDotWithCommaIfHasDecimal(x.qty)
                x.pickedqty = this.$formatter.replaceDotWithCommaIfHasDecimal(pickedQty || 0)
                x.rest = this.$formatter.replaceDotWithCommaIfHasDecimal(x.rest)
                x.deliveredqty = this.$formatter.replaceDotWithCommaIfHasDecimal(x.deliveredqty)
                if (x.isfreight || x.product_type === 'work') { // x.ispackage ||
                  x.rest = '0'
                }
                x.updatedon = this.$formatter.formatDate(x.updatedon, 'DD.MM.YYYY', 'DD.MM.YYYY')
                if (x.isfreight) {
                  x.producttext = 'Frakt'
                  x.number = '1000'
                }
                return x
              })
              resolve(getMaterialsForRest)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    getPickedQtyCalculatedList (allMaterials) {
      /* removed duplicated items by orderindex */
      var materials = allMaterials.filter(x => !x.orderindex)

      /* add splitter products qty to actual product by order index reference */
      var productsSplittedItems = allMaterials.filter(x => x.orderindex && x.pickedqty)
      var splittedItems = this.$_groupBy(productsSplittedItems, 'orderindex')
      Object.entries(splittedItems).forEach(orderIndex => { // [0] it is id of the actual product, [1] splitted products
        var productIndex = materials.findIndex(x => x.id === +orderIndex[0])
        if (productIndex > -1) {
          var totalqty = orderIndex[1].reduce((val, obj) => obj.pickedqty + val, 0)
          materials[productIndex].pickedqty += totalqty
        }
      })

      /* Set product type 'work' or 'isfreight' qty to pickedqty  */
      var productsToAutoSetPickedQty = materials.filter(x => x.isfreight || x.product_type === 'work')
      productsToAutoSetPickedQty.forEach((product, index) => {
        var productIndex = materials.findIndex(x => x.id === product.id)
        if (productIndex > -1) materials[productIndex].pickedqty = materials[productIndex].qty
      })
      /*  */
      /* get toplist products (package also product) */
      var topListProducts = materials.filter(x => !x.packageid && !x.mainpackageid)
      /* packageProducts */
      // var packageProducts = materials.filter(x => x.packageid || x.mainpackageid)
      // topListProducts.forEach(x => {
      //   const condition = x.product_isproduction ? x.isproductionorder && x.ispackage : x.ispackage
      //   if (condition) this.getContents(x, packageProducts)
      //   // else x.pixk
      // })
      return topListProducts
    },
    getContents (contentPackage, packageProducts) {
      var innercontents = []
      var contentProducts = packageProducts.filter(x => x.packageid === contentPackage.id)
      var contentPakages = packageProducts.filter(x => x.mainpackageid === contentPackage.id)
      contentPakages.forEach(y => {
        if (y.ispackage) this.getContents(y, packageProducts)
      })
      innercontents = [...contentProducts, ...contentPakages]
      /* get innercontents pickedqty percent by value */
      const findTotalPercent = (val, product) => {
        var percent = 0
        if (product.pickedqty && product.qty) percent = (product.pickedqty / product.qty) * 100
        return (percent + val)
      }
      var totalPercent = innercontents.reduce(findTotalPercent, 0)
      totalPercent = totalPercent / innercontents.length
      /* set package's pickedqty value by percent */
      var pickedValue = (totalPercent * contentPackage.qty) / 100
      contentPackage.pickedqty = pickedValue || 0
      return innercontents
    },
    $_groupBy (array, key) {
      return array.reduce(function (total, item) {
        total[item[key]] = total[item[key]] || []
        total[item[key]].push(item)
        return total
      }, {})
    }
  }
}
